import {
  SET_HERO_BANNER,
  SET_HERO_BANNERS,
  SET_FEATURED,
  SET_FEATURE_STATUS,
  SET_OFFERS,
  SET_PROMOS,
  SET_EVENTS,
  SET_MOVIES,
  SET_MALLS,
  SET_CMS_MALLS,
  SET_MERCHANTS,
  SET_MARKETING_CONTENT_DATA,
  SET_MARKETING_CONTENT_STATUS,
  SET_MERCHANTS_LIST_MODAL_DATA,
  SET_STORE_MODAL_DATA,
  SET_DEVICE_LOCATION,
  SET_CURRENT_MALL_IN_MODAL,
  SET_OUR_MALL_MODAL_STATUS,
  SET_CARD_LIST_MODAL_DATA,
  SET_CARD_LIST_MODAL_STATUS,
  SET_CINEMAS,
  SET_PASYAL_ARTICLES,
  SET_HERO_BANNER_PROMOS_AND_EVENTS,
} from './types'

export const setHeroBanner = heroBanner => ({
  type: SET_HERO_BANNER,
  payload: {
    heroBanner,
  },
})

export const setHeroBannerPromosAndEvents = heroBannerPromosAndEvents => ({
  type: SET_HERO_BANNER_PROMOS_AND_EVENTS,
  payload: {
    heroBannerPromosAndEvents,
  },
})

export const setHeroBanners = heroBanners => ({
  type: SET_HERO_BANNERS,
  payload: {
    heroBanners,
  },
})

export const setFeatured = featured => ({
  type: SET_FEATURED,
  payload: {
    featured,
  },
})

export const setFeatureStatus = featureStatus => ({
  type: SET_FEATURE_STATUS,
  payload: {
    featureStatus,
  },
})

export const setOffers = offers => ({
  type: SET_OFFERS,
  payload: {
    offers,
  },
})

export const setPromos = promos => ({
  type: SET_PROMOS,
  payload: {
    promos,
  },
})

export const setEvents = events => ({
  type: SET_EVENTS,
  payload: {
    events,
  },
})

export const setMovies = movies => ({
  type: SET_MOVIES,
  payload: {
    movies,
  },
})

export const setMalls = malls => ({
  type: SET_MALLS,
  payload: {
    malls,
  },
})

export const setCMSMalls = cmsMalls => ({
  type: SET_CMS_MALLS,
  payload: {
    cmsMalls,
  },
})

export const setMerchants = merchants => ({
  type: SET_MERCHANTS,
  payload: {
    merchants,
  },
})

export const setMarketingContentModalData = marketingContentModalData => ({
  type: SET_MARKETING_CONTENT_DATA,
  payload: {
    marketingContentModalData,
  },
})

export const setMarketingContentModalStatus = marketingContentModalStatus => ({
  type: SET_MARKETING_CONTENT_STATUS,
  payload: {
    marketingContentModalStatus,
  },
})

export const setMerchantsListModalData = merchantsListModalData => ({
  type: SET_MERCHANTS_LIST_MODAL_DATA,
  payload: {
    merchantsListModalData,
  },
})

export const setStoreModalData = storeModalData => ({
  type: SET_STORE_MODAL_DATA,
  payload: {
    storeModalData,
  },
})

export const setDeviceLocation = deviceLocation => ({
  type: SET_DEVICE_LOCATION,
  payload: {
    deviceLocation,
  },
})

export const setCurrentMallInModal = currentMallInModal => ({
  type: SET_CURRENT_MALL_IN_MODAL,
  payload: {
    currentMallInModal,
  },
})

export const setOurMallModalStatus = ourMallModalStatus => ({
  type: SET_OUR_MALL_MODAL_STATUS,
  payload: {
    ourMallModalStatus,
  },
})

export const setCardListModalData = cardListModalData => ({
  type: SET_CARD_LIST_MODAL_DATA,
  payload: {
    cardListModalData,
  },
})

export const setCardListModalStatus = cardListModalStatus => ({
  type: SET_CARD_LIST_MODAL_STATUS,
  payload: {
    cardListModalStatus,
  },
})

export const setCinemas = cinemas => ({
  type: SET_CINEMAS,
  payload: {
    cinemas,
  },
})

export const setPasyalArticles = pasyalArticles => ({
  type: SET_PASYAL_ARTICLES,
  payload: {
    pasyalArticles,
  },
})
